<!--
 * @Author: pengyong
 * @Date: 2020-11-13 23:24:51
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-03 22:10:15
 * @Description: 注册
 * @FilePath: /exhibit/src/views/register/index.vue
-->
<template>
    <Wrapper :modalWidth="7" :modalHeight="12">
        <div class="register-wrapper">
            <div class="tabs">
                <div :class="['tab', current === list.id && 'current']" v-for="list in tabs" :key="list.id" @click="changeTab(list)">
                    {{ list.text }}
                </div>
            </div>
            <input type="password" style="position:fixed;right:-3333px;top: -3333px;" />
            <div class="form">
                <div class="form-item">
                    <el-select filterable class="select" v-model="country" :placeholder="$t('register').countryPlaceholder">
                        <el-option v-for="item in countrys" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
                <div class="form-item">
                    <input v-model="name" class="ipt" type="text" :placeholder="$t('register').namePlaceholder" />
                </div>
                <div class="form-item">
                    <input v-model="company" class="ipt" type="text" :placeholder="$t('register').companyPlaceholder" />
                </div>
                <div class="form-item" v-if="current === 0">
                    <el-select class="select select-phone" v-model="areaCode" placeholder="请选择">
                        <el-option v-for="item in phones" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                    <input v-model="phone" maxlength="11" class="ipt" type="text" :placeholder="$t('login').phonePlaceholder" />
                </div>
                <div class="form-item" v-if="current === 1">
                    <input v-model="email" class="ipt" type="text" :placeholder="$t('login').emailPlaceholder" />
                </div>
                <div class="form-item form-item-code">
                    <div class="form-item-left">
                        <input v-model="code" class="ipt" :placeholder="$t('login').codePlaceholder" type="text" />
                    </div>
                    <div :class="['form-item-right', disabledSendCode && 'disabled']" @click="handleGetCode">
                        {{ hasSend ? count : $t("login").sendCode }}
                    </div>
                </div>
                <div class="form-item form-item-psw">
                    <input v-model="password" class="ipt" :type="showPassword ? 'text' : 'password'" :placeholder="$t('register').pswPlaceholder" />
                    <div class="suffix">
                        <img
                            :class="[showPassword ? 'eye-hide' : 'eye']"
                            @click="showPassword = !showPassword"
                            :src="showPassword ? require('@/assets/eye-hide.png') : require('@/assets/eye.png')"
                            alt=""
                        />
                    </div>
                </div>
                <CommonButton style="margin-top: 20px;margin-bottom:13px;" :disabled="disabled" @click="handleSubmit">
                    {{ $t("register").register }}
                </CommonButton>
                <div class="tip">
                    {{ $t("register").tip }}<router-link to="/mobileLogin" tag="span">{{ $t("register").loginTip }}</router-link>
                </div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import CommonButton from "@/components/CommonButton";
import Wrapper from "@/components/CommomMobileWrapper";
import api from "@/api";

export default {
    components: {
        Wrapper,
        CommonButton
    },
    data() {
        return {
            current: 0,
            countrys: [],
            phones: [
                {
                    label: "+86",
                    value: "+86"
                }
            ],
            country: "",
            name: "",
            company: "",
            phone: "",
            email: "",
            password: "",
            code: "",
            showPassword: false,
            hasSend: false,
            count: 60,
            areaCode: "+86"
        };
    },
    computed: {
        tabs() {
            return [
                { text: this.$t("register").phoneReg, id: 0 },
                { text: this.$t("register").emailReg, id: 1 }
            ];
        },
        disabled() {
            // 禁止注册
            const isComplete = !!(this.country && this.name && this.company && this.code && this.password);
            return this.current === 0 ? !(isComplete && this.phone) : !(isComplete && this.email);
        },
        disabledSendCode() {
            if (this.current === 0 && !this.phone) {
                return true;
            }
            if (this.current === 1 && !this.email) {
                return true;
            }
            return this.hasSend;
        }
    },
    mounted() {
        this.getCountry();
    },
    methods: {
        getCountry() {
            api.getCountry().then((res) => {
                if (res.res === 1) {
                    const defaultLanguage = localStorage.getItem("language") || "zh";
                    this.countrys = res.country.map((item) => {
                        return {
                            value: item.code,
                            label: defaultLanguage === "zh" ? item.zh : item.en
                        };
                    });
                }
            });
        },
        changeTab(list) {
            this.current = list.id;
            this.showPassword = false;
            this.hasSend = false;
            this.count = 60;
        },
        async handleGetCode() {
            if (this.disabledSendCode) return;
            try {
                this.hasSend = true;
                let res = {};
                if (this.current === 0) {
                    res = await api.sendSmsCode({ phone: this.phone });
                } else {
                    res = await api.sendEmailCode({ email: this.email });
                }
                if (res.res === 1) {
                    this.count = 60;
                    clearInterval(this.timer);
                    this.startTime = new Date().getTime();
                    this.timer = setInterval(() => {
                        let countDownTime = Math.round(60 - (new Date().getTime() - this.startTime) / 1000);
                        if (countDownTime <= 0) {
                            this.hasSend = false;
                            this.count = 60;
                            clearInterval(this.timer);
                        } else {
                            this.count = countDownTime;
                        }
                    }, 1000);
                } else {
                    this.hasSend = false;
                    this.count = 60;
                    clearInterval(this.timer);
                    this.$message.error(res.message);
                }
            } catch (error) {
                this.hasSend = false;
                this.count = 60;
                clearInterval(this.timer);
            }
        },
        handleSubmit() {
            const params = {
                real_name: this.name,
                password: this.password,
                verify_code: this.code,
                country_code: this.country,
                company: this.company
            };
            if (this.current === 0) {
                params["phone"] = this.phone;
            } else {
                params["email"] = this.email;
            }
            api.register(params).then((res) => {
                if (res.res === 1) {
                    localStorage.setItem("access_token", res.access_token);
                    localStorage.setItem("token_type", res.token_type);
                    this.$message.success("注册成功");
                    this.$router.push("/exhibition");
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.register-wrapper {
    padding: .4rem;
    position: relative;
    overflow: hidden;
    .tabs {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        .tab {
            color: rgba(9, 70, 140, 0.45);
            cursor: default;
            font-weight: 500;
            &.current {
                color: rgba(9, 70, 140, 1);
            }
        }
    }
    .form {
        padding-top: 27px;
        .select {
            height: 40px;
            border-radius: 13px;
            width: 100%;
            /deep/ .el-input {
                font-size: 16px;
                .el-input__suffix {
                    right: 0;
                    width: 43px;
                    height: 40px;
                    background: rgba(9, 70, 140, 1);
                }
                .el-input__inner {
                    border: none;
                    background: transparent;
                }
                .el-select__caret {
                    font-size: 16px;
                    color: #fff;
                }
            }
            &.select-phone {
                width: 79px;
                background: rgba(9, 70, 140, 1);
                /deep/ .el-input {
                    .el-input__inner {
                        color: #fff;
                        padding-left: 13px;
                    }
                    .el-input__suffix {
                        width: 38px;
                    }
                }
            }
        }
        .form-item {
            height: 40px;
            background: rgba(9, 70, 140, 0.09);
            border-radius: 13px;
            margin-bottom: 13px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            overflow: hidden;
            color: rgba(9, 70, 140, 1);
            font-size: 16px;
            .prefix,
            .suffix {
                width: 43px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
            }
            .prefix-account {
                img {
                    width: 16px;
                    height: 16px;
                }
            }
            .prefix-psw {
                img {
                    width: 13px;
                    height: 16px;
                }
            }
            .prefix-code {
                img {
                    width: 16px;
                    height: 19px;
                }
            }
            .ipt {
                height: 40px;
                line-height: 40px;
                flex: 1;
                background: transparent;
                font-size: 16px;
                color: rgba(9, 70, 140, 1);
                padding: 0 13px;
                border-radius: 13px;
            }
            .eye-hide {
                width: 16px;
                height: 7px;
                cursor: pointer;
            }
            .eye {
                width: 16px;
                height: 12px;
                cursor: pointer;
            }
        }
        .form-item-code {
            background: transparent;
            border-radius: none;
            box-shadow: none;
            overflow: inherit;
            .form-item-left {
                width: 200px;
                background: rgba(9, 70, 140, 0.09);
                border-radius: 13px;
                display: flex;
                align-items: center;
            }
            .form-item-right {
                width: 113px;
                height: 40px;
                line-height: 40px;
                background: rgba(9, 70, 140, 1);
                border-radius: 13px;
                text-align: center;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;
                &.disabled {
                    background: rgba(9, 70, 140, 0.45);
                    cursor: not-allowed;
                }
            }
        }
        .form-item-psw {
            ::-webkit-input-placeholder {
                /* WebKit browsers */
                font-size: 9px;
            }
        }
        .action {
            font-size: 11px;
            font-weight: 400;
            color: rgba(9, 70, 140, 1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            .auto-login {
                display: flex;
                align-items: center;
                cursor: pointer;
                .checked,
                .unchecked {
                    width: 16px;
                    height: 16px;
                    border-radius: 13px;
                    margin-right: 7px;
                    margin-top: -2px;
                    box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4),
                        0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                }
                .checked {
                    background: #4f8af8;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 11px;
                        height: 7px;
                    }
                }
                .unchecked {
                    background: #dfe8f9;
                }
            }
        }
        .tip {
            font-size: 11px;
            font-weight: 500;
            color: rgba(9, 70, 140, 1);
            text-align: center;
            cursor: pointer;
            span {
                color: #4f8af8;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobileRegister/index.vue